import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Michael Chen",
      role: "Owner, Chen's Plumbing",
      content: "Finally, an agency that understands where marketing is heading. The AI approach is exactly what local businesses need.",
      rating: 5,
      avatar: "MC",
    },
    {
      name: "Sarah Thompson",
      role: "Partner, Thompson Legal",
      content: "We were skeptical at first, but the team at AI Ads Flow really knows their stuff. Excited to be early adopters.",
      rating: 5,
      avatar: "ST",
    },
    {
      name: "David Rodriguez",
      role: "CEO, CleanPro Services",
      content: "The automation aspect is a game-changer. We can focus on our clients while leads come in on autopilot.",
      rating: 5,
      avatar: "DR",
    },
  ];

  const stats = [
    { value: "50+", label: "Businesses Ready" },
    { value: "4", label: "AI Platforms" },
    { value: "100%", label: "Automated" },
    { value: "24/7", label: "Support" },
  ];

  return (
    <section className="py-12 md:py-20 relative">
      <div className="container mx-auto px-4 max-w-[1280px]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center space-y-4 mb-12"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold">
            Trusted by <span className="text-gradient">Forward-Thinking</span> Businesses
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Join the businesses getting ready for the AI advertising revolution.
          </p>
        </motion.div>

        {/* Stats */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12"
        >
          {stats.map((stat, index) => (
            <div
              key={index}
              className="glass rounded-2xl p-6 text-center hover:border-primary/30 hover:shadow-lg hover:shadow-primary/5 transition-all"
            >
              <div className="text-3xl md:text-4xl font-bold text-gradient mb-1">
                {stat.value}
              </div>
              <p className="text-sm text-muted-foreground">{stat.label}</p>
            </div>
          ))}
        </motion.div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="glass rounded-2xl p-6 hover:border-primary/50 hover:shadow-lg hover:shadow-primary/5 transition-all group"
            >
              <Quote className="h-8 w-8 text-primary/30 mb-4 group-hover:text-primary/50 transition-colors" />
              
              <p className="text-foreground mb-6">{testimonial.content}</p>
              
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-accent text-accent" />
                ))}
              </div>
              
              <div className="flex items-center gap-3">
                <Avatar className="h-10 w-10 border-2 border-primary/30">
                  <AvatarFallback className="bg-primary/20 text-primary font-semibold text-sm">
                    {testimonial.avatar}
                  </AvatarFallback>
                </Avatar>
                <div>
                  <p className="font-semibold">{testimonial.name}</p>
                  <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
